export type AvailableProductsResponse = {
	isOpenInCurrentTabEnabled?: boolean;
	isPartial: boolean;
	links: AvailableLink[];
	sites: AvailableSite[];
	startUrl?: string;
};

interface AvailableLink {
	linkType: string;
	url: string;
}

export type AvailableSite = {
	adminAccess: boolean;
	availableProducts: AvailableProduct[];
	avatar: string | null;
	cloudId?: string;
	displayName: string;
	isBerryTwist: boolean;
	org?: Organisation;
	unit?: Unit;
	url: string;
};

type AvailableProduct = {
	activationDate?: string;
	adminActivationDate?: string;
	autoProvisionDate?: string;
	companyHubName?: string;
	endUserActivationDate?: string;
	firstActiveDate?: string;
	isCompanyHubPublishedAndPremium?: boolean;
	isJsmPremium?: boolean;
	productType: SwitcherProductType;
	url: string;
};

interface Organisation {
	displayName: string;
	id: string;
}

interface Unit {
	displayName: string;
	id: string;
}

type SwitcherProductType =
	| FlightDeckProductType
	| InternalProductType
	| ThirdPartyProductType
	| CustomLinkType
	| OverflowButtonType;

// The product keys need to match registered products in Flight Deck:
// https://bitbucket.org/atlassian/flight-deck/src/master/packages/integrations/twp-switch-to-products/contrib/
type FlightDeckProductType =
	| 'ANALYTICS'
	| 'BEACON'
	| 'BITBUCKET'
	| 'COMPASS'
	| 'CONFLUENCE'
	| 'JIRA_CUSTOMER_SERVICE'
	| 'JIRA_PRODUCT_DISCOVERY'
	| 'JIRA_SERVICE_DESK'
	| 'JIRA_SOFTWARE'
	| 'JIRA_BUSINESS'
	| 'mercury'
	| 'OPSGENIE'
	| 'ROVO'
	| 'TALENT'
	| 'STATUSPAGE'
	| 'TEAM_CENTRAL'
	| 'TRELLO'
	| 'LOOM'
	| 'DEVAI'
	| 'DX'
	| 'FEEDBACK';

// those product keys are only used internally in the app
type InternalProductType =
	| 'ATLASSIAN_HOME'
	| 'ASSETS'
	| 'COMPANY_HUB'
	| 'TEAMS'
	| 'GOALS'
	| 'PROJECTS'
	| 'SEARCH'
	| 'CHAT'
	| 'STUDIO'
	| 'ADMINISTRATION';

//TODO: Clean up/find a better way to do this
export type ThirdPartyProductType = 'THIRD_PARTY' | string;

export type CustomLinkType = 'CUSTOM_LINK';

export type OverflowButtonType = 'OVERFLOW_MORE_BUTTON' | 'OVERFLOW_LESS_BUTTON';

/**
 * Source of the current site selection. Used both as the default value of
 * `previousSelectionSourceAtom` (in `state/site-state`) and as the
 * `previousSelectionSource` attribute on the
 * `ui.dropdownItem.clicked.twgMicrositeSiteSwitcher` analytics event.
 */
export enum SiteSelectionSource {
	Default = 'default',
	SavedPreference = 'savedPreference',
	UserSelection = 'userSelection',
}

/**
 * Reason the SiteSwitcher dropdown closed. Used as the `closeReason`
 * attribute on the `ui.dropdown.closed.twgMicrositeSiteSwitcher` analytics
 * event.
 */
export enum SiteSwitcherCloseReason {
	ItemSelected = 'itemSelected',
	Dismissed = 'dismissed',
}
